export enum DamageField {
  Line = 'line',
  LineSystem = 'lineSystem',
  Notice = 'notice',
  ClientComment = 'clientComment',
}
